























  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import {swiper, swiperSlide} from 'vue-awesome-swiper';

  @Component({
    components: {
      swiper,
      swiperSlide,
    },
  })
  export default class PartThreeMore extends Vue {
    private partThreeActive: number = 1;

    get swiperOption() {
      const that = this;
      return {
        autoHeight: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet(index: number, className: string) {
            const render: any = [
              {
                title: '换电站',
                description: '全球首创全自动换电技术，三分钟完成换电，满电出发',
              },
              {
                title: '充电车',
                description: '快速前往现场为车辆充电，10分钟补充 100公里续航',
              },
              {
                title: '公共桩',
                description: '全国范围广泛接入蔚来能源网络的公共直流充电桩',
              },
            ];
            return `<li class="${className} swiper-pagination-bullet-custom">
<h2 class="font-size-40">${render[index].title}</h2>
            <p>${render[index].description}</p>
</li>`;
          },
        },
      };
    }

    private swiperData: any = [
      {
        src: require('@/assets/images/3-1.png'),
      },
      {
        src: require('@/assets/images/3-2.png'),
      },
      {
        src: require('@/assets/images/3-3.png'),
      },
    ];

    private closeLearnMore() {
      this.$emit('closeLearnMore', false);
    }

  }
